import { ButtonTheme } from '@philips-internal/oswald-ui-constants';
import { bool, expression, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
const PDFViewerProperties = {
    buttonTheme: {
        defaultValue: ButtonTheme.PRIMARY,
        type: oneOf(enumValues(ButtonTheme)),
    },
    downloadingPdfExpression: {
        defaultValue: 'oswald.pdf-viewer.downloading',
        type: expression,
    },
    downloadPdfExpression: {
        defaultValue: 'oswald.pdf-viewer.download',
        type: expression,
    },
    loading: {
        type: bool,
    },
    openPdfExpression: {
        defaultValue: 'oswald.pdf-viewer.open',
        type: expression,
    },
    showDownloadButton: {
        type: bool,
    },
    src: {
        type: string,
    },
    uuid: {
        type: string,
    },
    visible: {
        defaultValue: true,
        type: bool,
    },
};
export { PDFViewerProperties, };
//# sourceMappingURL=pdf-viewer-types.js.map